import React, { useEffect, useState, Fragment } from 'react';
import { ClockIcon } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="bg-white rounded-2xl p-6 shadow-medium border border-accent-urgency/20" data-id="element-247">
      <div className="flex items-center justify-center gap-2 mb-4" data-id="element-248">
        <ClockIcon className="w-5 h-5 text-accent-urgency animate-pulse" data-id="element-249" />
        <span className="text-sm font-bold text-deep-cocoa uppercase tracking-wide" data-id="element-250">
          Oferta termina en:
        </span>
      </div>

      <div className="flex items-center justify-center gap-3" data-id="element-251">
        {[{
        value: timeLeft.hours,
        label: 'Horas'
      }, {
        value: timeLeft.minutes,
        label: 'Min'
      }, {
        value: timeLeft.seconds,
        label: 'Seg'
      }].map((item, index) => <Fragment key={item.label} data-id="element-252">
            {index > 0 && <span className="text-2xl font-bold text-deep-cocoa/30" data-id="element-253">:</span>}
            <div className="flex flex-col items-center bg-gradient-to-br from-accent-urgency/10 to-accent-urgency/5 rounded-xl px-4 py-3 min-w-[70px]" data-id="element-254">
              <span className="text-3xl sm:text-4xl font-black text-deep-cocoa tabular-nums" data-id="element-255">
                {String(item.value).padStart(2, '0')}
              </span>
              <span className="text-xs uppercase tracking-wider text-deep-cocoa/60 font-semibold mt-1" data-id="element-256">
                {item.label}
              </span>
            </div>
          </Fragment>)}
      </div>
    </div>;
}